import React from 'react';
import PropTypes from 'prop-types';
import ACTreeNode from './ACTreeNode';
import { useACDictionaryContext } from '../ACContext/ACDictionaryContext';

const ACDictionaryTree = ({ nodeClickHandler }) => {
  const { dictionary = [] } = useACDictionaryContext();

  return (
    <React.Fragment>
      {dictionary.length === 0 && <div>No results found</div>}
      {dictionary.map(node => (
        <ACTreeNode
          key={node.textPath}
          node={node}
          clickHandler={nodeClickHandler}
          level={1}
        />
      ))}
    </React.Fragment>
  );
};

ACDictionaryTree.propTypes = {
  nodeClickHandler: PropTypes.func,
};

export default ACDictionaryTree;
